export default __webpack_public_path__ + "static/media/output.9d62129d.svg";